import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/report',
  component: layout,
  children: ((pre) => [
    {
      path: 'reportSample',
      name: `${pre}reportSample`,
      meta: {
        ...meta,
        cache: true,
        title: '样品资料提交统计',
        head: true,
        funcID: 'B0501',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/report/reportSample'),
    },
    {
      path: 'reportSampleBorrow',
      name: `${pre}reportSampleBorrow`,
      meta: {
        ...meta,
        cache: true,
        title: '样品外借统计',
        head: true,
        funcID: 'B0502',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/report/reportSampleBorrow'),
    },
    {
      path: 'reportSampleStorage',
      name: `${pre}reportSampleStorage`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'B0503',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/report/reportSampleStorage'),
    },
    {
      path: 'reportSampleReturn',
      name: `${pre}reportSampleReturn`,
      meta: {
        ...meta,
        cache: true,
        title: '样品归还统计',
        head: true,
        funcID: 'B0504',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/report/reportSampleReturn'),
    },
  ])('report-'),
}
